import React, { Fragment } from "react";
import { Card, CardBody, Badge, CustomInput, Button } from "reactstrap";
import { NavLink } from "react-router-dom";

import { Colxx } from "../../../../../../components/common/CustomBootstrap";
import ProductFormButton from "./ProductFormButton";

const ProductListItem = ({ item, toggleModal, LoadData }) => {
  function generateRandomColor() {
    var arr = [
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger',
      'light',
      'dark',
    ];
    return arr[Math.floor(Math.random() * arr.length)];
  }
  return (
    <Colxx xxs="12">
      <Card className="d-flex flex-row mb-3">
        <div className="pl-2 d-flex flex-grow-1 min-width-zero col-10">
          <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
            <p className="mb-1  text-small w-15 w-sm-100">
              <b>{item.title != null ? item.title[0].statement : ''}</b>
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              {item.type}
            </p>
            <p className="mb-1  text-small w-15 w-sm-100">
              <b>{item.shortDescription != null ? item.shortDescription[0].statement : ''}</b>
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              {item.categories.map((tag, index) => {
                return (
                  <Fragment>
                    {' '}
                    <Badge color={generateRandomColor()} className="mt-1" >{tag}</Badge>{' '}
                  </Fragment>
                );
              })}
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              {item.tags.map((tag, index) => {
                return (
                  <Fragment>
                    {' '}
                    <Badge color={generateRandomColor()} className="mt-1" >{tag}</Badge>{' '}
                  </Fragment>
                );
              })}
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              {item.status}
            </p>
            <div className="w-15 w-sm-100">
              <ProductFormButton
                id={item.id}
                LoadData={LoadData}
              >
              </ProductFormButton>
            </div>
          </div>
        </div>
      </Card>
    </Colxx>
  );
};

export default React.memo(ProductListItem);
